import { Link } from "react-scroll";
import menu from "../imgs/menu-icon.png"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import { faX } from '@fortawesome/free-solid-svg-icons'

function expandMenu() {
    document.getElementsByClassName("nav-container")[0].style.display = "block"
    document.getElementsByClassName("menu-icon")[0].style.display = "none"
    document.getElementsByClassName("exit-icon")[0].style.display = "block"
}

function collapseMenu() {
    document.getElementsByClassName("nav-container")[0].style.display = "none"
    document.getElementsByClassName("menu-icon")[0].style.display = "block"
    document.getElementsByClassName("exit-icon")[0].style.display = "none"
}

function Nav() {
    return (
        <div className="nav">
        <div className="responsive-topbar">
            <h2>
                <Link activeClass="active" onClick={() => collapseMenu()} smooth spy to="home-page">
                    CS1410
                </Link>
            </h2>
            <FontAwesomeIcon onClick={() => expandMenu()} className="menu-icon" icon={faBars} />
            <FontAwesomeIcon onClick={() => collapseMenu()} className="exit-icon" icon={faX}  />
        </div>
        <nav className="nav-container">
          <ul className="navlist">
            <li>
              <Link activeClass="active" onClick={() => collapseMenu()} smooth spy to="home-page">
                Home
              </Link>
            </li>
            <li>
              <Link activeClass="active" onClick={() => collapseMenu()} smooth spy to="lectures-page">
                Lectures
              </Link>
            </li>
            <li>
              <Link activeClass="active" onClick={() => collapseMenu()} smooth spy to="assignments-page">
                Assignments
              </Link>
            </li>
            <li>
              <Link activeClass="active" onClick={() => collapseMenu()} smooth spy to="resources-page">
                Resources
              </Link>
            </li>
            <li>
              <Link activeClass="active" onClick={() => collapseMenu()} smooth spy to="hours-page">
                Hours
              </Link>
            </li>
            <li>
              <Link activeClass="active" onClick={() => collapseMenu()} smooth spy to="staff-page">
                Staff
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    );
}
  
export default Nav;